var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAdminCalendar = function SvgAdminCalendar(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 7.91669H17.9166V16.6667C17.9166 17.1269 17.5435 17.5 17.0833 17.5H2.91659C2.45635 17.5 2.08325 17.1269 2.08325 16.6667V7.91669Z",
    stroke: "#7B8096",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 3.75002C2.08325 3.28978 2.45635 2.91669 2.91659 2.91669H17.0833C17.5435 2.91669 17.9166 3.28978 17.9166 3.75002V7.91669H2.08325V3.75002Z",
    stroke: "#7B8096",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 1.66669V5.00002",
    stroke: "#7B8096",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 1.66669V5.00002",
    stroke: "#7B8096",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 14.1667H14.1665",
    stroke: "#7B8096",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 14.1667H8.33325",
    stroke: "#7B8096",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 10.8334H14.1665",
    stroke: "#7B8096",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 10.8334H8.33325",
    stroke: "#7B8096",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAdminCalendar);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuMDgzMjUgNy45MTY2OUgxNy45MTY2VjE2LjY2NjdDMTcuOTE2NiAxNy4xMjY5IDE3LjU0MzUgMTcuNSAxNy4wODMzIDE3LjVIMi45MTY1OUMyLjQ1NjM1IDE3LjUgMi4wODMyNSAxNy4xMjY5IDIuMDgzMjUgMTYuNjY2N1Y3LjkxNjY5WiIgc3Ryb2tlPSIjN0I4MDk2IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMi4wODMyNSAzLjc1MDAyQzIuMDgzMjUgMy4yODk3OCAyLjQ1NjM1IDIuOTE2NjkgMi45MTY1OSAyLjkxNjY5SDE3LjA4MzNDMTcuNTQzNSAyLjkxNjY5IDE3LjkxNjYgMy4yODk3OCAxNy45MTY2IDMuNzUwMDJWNy45MTY2OUgyLjA4MzI1VjMuNzUwMDJaIiBzdHJva2U9IiM3QjgwOTYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02LjY2NjUgMS42NjY2OVY1LjAwMDAyIiBzdHJva2U9IiM3QjgwOTYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEzLjMzMzMgMS42NjY2OVY1LjAwMDAyIiBzdHJva2U9IiM3QjgwOTYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTExLjY2NjUgMTQuMTY2N0gxNC4xNjY1IiBzdHJva2U9IiM3QjgwOTYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuODMzMjUgMTQuMTY2N0g4LjMzMzI1IiBzdHJva2U9IiM3QjgwOTYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTExLjY2NjUgMTAuODMzNEgxNC4xNjY1IiBzdHJva2U9IiM3QjgwOTYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuODMzMjUgMTAuODMzNEg4LjMzMzI1IiBzdHJva2U9IiM3QjgwOTYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";